module.exports = __webpack_public_path__ + "4c13d18aefa3c503b89e89736682cc8e.ttf";


//////////////////
// WEBPACK FOOTER
// ./application/font/Roboto-BoldItalic.ttf
// module id = 342
// module chunks = 0